export const IDV_HEADER = "Answer your security questions";
export const IDV_SUB_HEADER = "For your security,please answer the question(s) below:";
export const IDV_INFO = "We use this information to verify your identity,and protect your account,so you must correctly complete the question(s) BEFORE your request can be submitted.";
export const IDV_SUB_HEADER_KBV = "To validate your identity and protect your account , please enter the primary cardmember's information below.";
